var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobTypesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.857,
    height: 20,
    viewBox: "889.571 564 22.857 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M903.857 577.571c0 .395-.32.715-.714.715h-4.286a.714.714 0 0 1-.714-.715v-2.142h-8.572v6.428c0 1.143 1 2.143 2.143 2.143h18.572c1.142 0 2.142-1 2.142-2.143v-6.428h-8.571v2.142Zm6.429-9.285h-3.572v-2.143c0-1.143-1-2.143-2.143-2.143h-7.143c-1.142 0-2.142 1-2.142 2.143v2.143h-3.572c-1.143 0-2.143 1-2.143 2.143V574h22.857v-3.571c0-1.143-1-2.143-2.142-2.143Zm-6.429 0h-5.714v-1.429h5.714v1.429Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-briefcase"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTypesIcon);
export default __webpack_public_path__ + "static/media/JobTypesIcon.7284744606965c1c5c99a98a4073e543.svg";
export { ForwardRef as ReactComponent };